module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    attrs: {
      "name": "blur",
      "tag": "div"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSrc === _vm.src),
      expression: "currentSrc === src"
    }],
    key: "image",
    staticClass: "blur-transition card-img",
    style: ({
      'border-radius': _vm.borderRadius
    }),
    attrs: {
      "src": _vm.src
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-61a242d2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/plPreloader/plPreloader.vue
// module id = 2366
// module chunks = 61